import { Button, Grid, Tooltip, Typography } from "@mui/material";
import Menu from "@mui/material/Menu";
import Link from "@mui/material/Link";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { useEffect, useState } from "react";
import { useShowController } from "react-admin";
import CustomLoanModifyDialog from "../../loans/actions/CustomLoanModifyDialog";
import CustomLoanOfflineDialog from "../../loans/actions/CustomLoanOfflineDialog";
import CustomLoanPortfolioDialog from "../../loans/actions/CustomLoanPortfolioDialog";
import CustomLoanPostponeDialog from "../../loans/actions/CustomLoanPostponeDialog";
import CustomLoanReduceDialog from "../../loans/actions/CustomLoanReduceDialog";
import CustomLoanSkipDialog from "../../loans/actions/CustomLoanSkipDialog";
import CustomLoanSwitchAchAccountDialog from "../../loans/actions/CustomLoanSwitchAchAccountDialog";
import CustomLoanSwitchAchDialog from "../../loans/actions/CustomLoanSwitchAchDialog";
import CustomLoanUpdateStatusDialog from "../../loans/actions/CustomLoanUpdateStatusDialog";
import CustomLoanUpdateChargedOffDialog from "../../loans/actions/CustomLoanUpdateChargedOffDialog";
import CustomLoanUpdateChargedOffStatusDialog from "../../loans/actions/CustomLoanUpdateChargedOffStatusDialog";
import useNotify from "../../unit/useNotify";
import CustomLoanRefundDialog from "../../loans/actions/CustomLoanRefundDialog";
import LoanActionsBackToList from "./LoanActionsBackToList";

const LinkNotAvailable = ({ ...props }) => {
  return (
    <Tooltip title="Functions not available" placement="left">
      <span
        style={{
          padding: "5px 0px",
          cursor: "pointer",
          display: "block",
          width: "100%",
        }}
      >
        <Link
          sx={{
            marginLeft: "26px",
            opacity: "0.38",
            "&": { textDecoration: "none" },
            "&:hover": {
              background: "none",
            },
            color: "grey",
          }}
        >
          {props?.title}
        </Link>
      </span>
    </Tooltip>
  );
};
const PositionedMenu = ({ ...props }) => {
  const appId = props.appId;
  const record = props.record;
  const sRepaymentPayment = props.sRepaymentPayment;
  const switchAch = props.switchAch;
  const todayModifyNum = props.todayModifyNum;
  const showSkipExtend = record?.showSkipExtend ? true : false;
  const havePendingTransfers = record?.havePendingTransfers ? true : false;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseMenu = () => {};
  return (
    <div>
      {todayModifyNum > 0 ? (
        <Tooltip
          title="Loan schedule has been modified today, reset schedule is not allowed"
          placement="left"
        >
          <span>
            <Button
              id="btn-reset-disabled-schedule"
              variant="contained"
              size="medium"
              color="error"
              disabled={true}
              sx={{
                marginLeft: "10px",
                width: "175px",
              }}
            >
              Reset Schedule
            </Button>
          </span>
        </Tooltip>
      ) : (
        <Button
          id="btn-reset-schedule"
          aria-controls={open ? "btn-reset-schedule" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          variant="contained"
          size="medium"
          color="error"
          sx={{
            marginLeft: "10px",
            width: "175px",
          }}
        >
          Reset Schedule
        </Button>
      )}

      <Menu
        id="menu-reset-schedule"
        aria-labelledby="menu-reset-schedule"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiMenuItem-root": {
            padding: "10 0",
            m: "0px",
            textAlign: "center",
            width: "260px",
            background: "none",
          },
          "& .MuiMenuItem-root:hover": {
            background: "none",
          },
        }}
      >
        {sRepaymentPayment == "SMART_ACH" || switchAch == "Completed" ? (
          <>
            <Typography
              variant="subtitle1"
              sx={{
                padding: "5px 10px 5px 26px",
                width: "320px",
                textAlign: "left",
                color: "red",
              }}
            >
              <span>
                &bull; Resetting payment schedule of any kind is limited to only
                once per day
              </span>
              <br />
              <span>
                &bull; Resetting function is unavailable when a payment transfer
                is in progress
              </span>
            </Typography>
            {showSkipExtend == false ? (
              <LinkNotAvailable title="Skip Upcoming Payment" />
            ) : (
              <MenuItem disabled={!showSkipExtend}>
                <CustomLoanSkipDialog
                  appId={appId}
                  record={record}
                  cb={handleCloseMenu}
                />
              </MenuItem>
            )}
            {showSkipExtend == false ? (
              <LinkNotAvailable title="Postpone Next Payment" />
            ) : (
              <MenuItem disabled={!showSkipExtend}>
                <CustomLoanPostponeDialog
                  appId={appId}
                  record={record}
                  cb={handleCloseMenu}
                />
              </MenuItem>
            )}
            {showSkipExtend == false ? (
              <LinkNotAvailable title="Reduce Select Payments" />
            ) : (
              <MenuItem disabled={!showSkipExtend}>
                <CustomLoanReduceDialog
                  appId={appId}
                  record={record}
                  cb={handleCloseMenu}
                />
              </MenuItem>
            )}
            {havePendingTransfers == true ? (
              <LinkNotAvailable title="Modify Loan Terms" />
            ) : (
              <MenuItem>
                <CustomLoanModifyDialog
                  appId={appId}
                  record={record}
                  cb={handleCloseMenu}
                />
              </MenuItem>
            )}
          </>
        ) : (
          <MenuItem>
            <CustomLoanModifyDialog
              appId={appId}
              record={record}
              cb={handleCloseMenu}
            />
          </MenuItem>
        )}

        <MenuItem onClick={handleClose} sx={{ pl: "25px" }}>
          <Link sx={{ textDecoration: "none" }}>Close</Link>
        </MenuItem>
      </Menu>
    </div>
  );
};

const LoanActions = ({ ...props }) => {
  const paramAppId = props.appId;
  let appId = "";
  let record = props.record;

  if (paramAppId != undefined && record != undefined) {
    appId = paramAppId;
  } else {
    const controllerProps = useShowController();
    record = controllerProps.record;
    appId = record ? record.id : "";
  }

  const [isLoading, setIsLoading] = useState(true);
  const { success, warning, error, info } = useNotify();

  useEffect(() => {
    if (appId) {
      setIsLoading(false);
    }
  }, [appId]);

  if (isLoading) {
    return <Typography>Application Action Loading...</Typography>;
  }
  if (record == undefined) {
    return <Typography>Application Action Loading...</Typography>;
  }

  const handleClick = () => {
    info("click button");
  };

  let switchAch = record?.appPayment?.sSwitchACH;
  let repaymentAccountData = record?.appPayment?.repaymentAccountData;
  let sRepaymentPayment = record?.appPayment?.sRepaymentPayment;
  if (
    sRepaymentPayment == undefined ||
    sRepaymentPayment == null ||
    sRepaymentPayment == ""
  ) {
    sRepaymentPayment = record?.loan?.sRepaymentPayment;
  }
  if (
    record.loan &&
    record?.loan?.appStatus == "Funded" &&
    record?.loan?.loanStatus == "Active"
  ) {
    return (
      <Grid
        container
        justifyContent="flex-end"
        sx={{ width: "100%", paddingRight: "0px" }}
      >
        <Grid item>
          <LoanActionsBackToList
            loanStatus={record?.loan?.loanStatus}
            curStatus={record?.loan?.curStatus}
            appId={appId}
            loannum={record?.loan?.loanNum}
            modify_num={record?.loan?.modify_num}
            maturityDate={record?.loan?.maturityDate}
            transferFatalErrorNumber={record?.loan?.transferFatalErrorNumber}
            transferFailedNumber={record?.loan?.transferFailedNumber}
            insufficientBalanceCheckNumber={
              record?.loan?.insufficientBalanceCheckNumber
            }
            smartach={sRepaymentPayment == "SMART_ACH" ? true : false}
          />
        </Grid>
        <Grid item xs>
          <Grid container justifyContent="flex-end" spacing={1}>
            {/* {(sRepaymentPayment == "SMART_ACH" || switchAch == "Completed") && ( */}
            <>
              <PositionedMenu
                appId={appId}
                record={record}
                sRepaymentPayment={sRepaymentPayment}
                switchAch={switchAch}
                todayModifyNum={record?.loan?.todayModifyNum}
              />
            </>
            {/* )} */}
            {sRepaymentPayment == "MANUAL_ACH" && (
              <CustomLoanUpdateStatusDialog appId={appId} record={record} />
            )}
            {sRepaymentPayment == "SMART_ACH" && (
              <CustomLoanOfflineDialog appId={appId} record={record} />
            )}
            {sRepaymentPayment == "SMART_ACH" ? (
              <CustomLoanUpdateStatusDialog appId={appId} record={record} />
            ) : (
              <>
                {switchAch == "Completed" && (
                  <CustomLoanSwitchAchAccountDialog
                    app={appId}
                    repaymentAccountData={repaymentAccountData}
                  />
                )}
                {switchAch == "Start" && (
                  <Button
                    variant="contained"
                    size="medium"
                    disabled={true}
                    sx={{ marginLeft: "10px" }}
                  >
                    Pending borrower payment source
                  </Button>
                )}
                {switchAch != "Completed" && switchAch != "Start" && (
                  <CustomLoanSwitchAchDialog appId={appId} record={record} />
                )}
              </>
            )}
            {sRepaymentPayment == "SMART_ACH" &&
              record?.loan?.bank == "ircceo" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
            {record?.loan?.bank == "nolb" && (
              <CustomLoanPortfolioDialog appId={appId} record={record} />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  } else if (
    record?.loan?.appStatus == "Funded" &&
    record?.loan?.loanStatus == "Charged-Off"
  ) {
    return (
      <Grid container>
        <Grid item>
          <LoanActionsBackToList loanStatus={record?.loan?.loanStatus} />
        </Grid>
        <Grid item xs>
          <Grid container justifyContent="flex-end">
            <CustomLoanUpdateChargedOffDialog appId={appId} record={record} />
            <CustomLoanUpdateChargedOffStatusDialog
              appId={appId}
              record={record}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  } else if (
    record?.loan?.appStatus == "Funded" &&
    record?.loan?.loanStatus == "Paid-Off" &&
    record?.loan?.activePrincipalBalance < 0
  ) {
    return (
      <Grid
        container
        justifyContent={"right"}
        sx={{ width: "100%", textAlign: "right" }}
      >
        <Grid item>
          <LoanActionsBackToList
            loanStatus={record?.loan?.loanStatus}
            creditBalance={record?.loan?.activePrincipalBalance}
          />
        </Grid>
        <Grid item xs>
          <Grid container justifyContent="flex-end">
            <CustomLoanRefundDialog appId={appId} record={record} />
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container sx={{ width: "100%", textAlign: "right" }}>
        <Grid item>
          <LoanActionsBackToList loanStatus={record?.loan?.loanStatus} />
        </Grid>
        {/* no action */}
      </Grid>
    );
  }
};

export default LoanActions;
